import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildingComponent } from './components/building/building.component';
import { LogoComponent } from './components/logo/logo.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SelectCountryComponent } from './components/select-country/select-country.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpErrorInterceptor } from './gateways/http-error-interceptor';
import { InfoComponent } from './components/info/info.component';
import { ParentalGateComponent } from './components/parental-gate/parental-gate.component';
import { ParentalGateDirective } from './components/parental-gate/parental-gate.directive';
import { ActivatedRoute } from '@angular/router';
import { STORE } from './utils/constants';
import { I18N_URL_SUFFIX, supportedLang, urlLang } from './utils/lang';

// AoT requires an exported function for factories
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, './assets/i18n/', I18N_URL_SUFFIX);
}

@NgModule({
  declarations: [BuildingComponent, LogoComponent, SelectCountryComponent, InfoComponent, ParentalGateComponent, ParentalGateDirective],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    BuildingComponent,
    LogoComponent,
    SelectCountryComponent,
    InfoComponent,
    ParentalGateComponent,
    ParentalGateDirective,
  ],
  providers: [{ provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true }],
})
export class SharedModule {
  constructor(private translateService: TranslateService, private readonly route: ActivatedRoute) {
    this.translateService.addLangs(['en', 'fr']);
    // Missing keys fall back to English instead of showing the raw key.
    this.translateService.setDefaultLang('en');

    this.route.queryParams.subscribe((params) => {
      // The router only publishes query params once the first navigation completes,
      // which a route guard (parental gate) can hold back, so also read the raw URL.
      const lang = params['lang'] ?? urlLang();
      if (lang) {
        console.log('detect language in url', lang);
      } else {
        console.log('detect language from browser', this.translateService.getBrowserLang());
      }

      const selectedLang = supportedLang(lang ?? this.translateService.getBrowserLang());
      console.log('Using language for page', selectedLang);
      this.translateService.use(selectedLang);
      console.log('TranslateService language ', this.translateService.currentLang);

      if (params['uuid']) {
        localStorage.setItem(STORE.USER_UUID, params['uuid']);
      }
    });
  }

}
